import type { TreeWithCourses } from "src/shared/api-types/certificate";

/**
 * A member whose profile setup is incomplete has roles but no positions
 * assigned anywhere in the relation tree. Because operations are nested under
 * positions, "no positions" also implies "no operations". This mirrors the
 * "role acting as its own position" case rendered in the Positions tab.
 */
export const hasNoUserProperties = (relationTree?: TreeWithCourses | null): boolean => {
  const roles = relationTree?.roles;
  if (!roles || roles.length === 0) {
    return false;
  }
  return roles.every((role) => role.positions.length === 0);
};
